import {Button, Grid, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import {Group} from '../../../graphql/groups.datatypes';
import {getHost} from '../../../graphql/GraphQlProvider';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(0),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(3),
    },
  },
  heading: {
    paddingBottom: theme.spacing(1.5),
    fontFamily: 'Recoleta-SemiBold',
    textAlign: 'center',
    fontSize: 40,
    letterSpacing: -0.4,
    lineHeight: '1.2em',
    margin: '0 auto',

    [theme.breakpoints.up('sm')]: {
      maxWidth: '12em'
    },

    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
  },
  body: {
    padding: theme.spacing(2),
    paddingTop: 0,
    fontFamily: 'Nunito',
    fontSize: 18,
    letterSpacing: 30 / 1000,
    textAlign: 'center',
  },
  image: {
    height: 'auto',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
        width: `calc(100% - ${theme.spacing(4)}px)`,
        marginLeft: theme.spacing(2)
    },
  },
  bookNowContainer: {
    marginTop: 16,
    marginBottom: 64,
  },
  button: {
    borderRadius: 0,
    borderWidth: 2,
    textTransform: 'none',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),

    '&:hover, &.Mui-focusVisible': {
      borderRadius: 0,
      borderWidth: 2,
      textTransform: 'none',
    },
  },
  bookNow: {
    fontSize: 16,
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,

  },
  partyPopper: {
    position: 'relative',
    right: -10,
    fontSize: 20,
  },
  cannon: {
    height: '34vh',
    width: 1,
    position: 'absolute',
    bottom: 18,
    left: '73%',
    transformOrigin: '50% 100%',
    cubicBezier: '(0.18, 0.89, 0.32, 1.28) both',
    transform: 'scale(0)',
  },
  cannonExplosion: {
    '& $cannon': {
      animation: '$cannonExplosion 1s 1',
      }
  },
  '@keyframes cannonExplosion': {
    '0%': { transform: 'scale(0)'},
    '80%': { opacity: 1, transform: 'scale(1)'},
    '100%': { opacity: 0, transform: 'scale(1)'},
  },
  cannonPath: {
    position: 'absolute',
    bottom: 5,
    left: 5,
    width: '100%',
    transformOrigin: '50% 100%',
    paddingBottom: '30%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  cannonPathLg: {
      height: '100%',
    },
  cannonPathMd: {
      height: '95%',
  },
  cannonPathSm: {
      height: '90%',
  },
  cannonPathAngle22: {
  transform: 'rotate(35deg)',
},
cannonPathAngle11: {
  transform: 'rotate(25deg)',
},
cannonPathAngle1: {
  transform: 'rotate(45deg)',
},
cannonPathAngle2: {
  transform: 'rotate(55deg)',
},
cannonPathAngle0: {
  transform: 'rotate(15deg)',
},
cannonConfetti: {
  flex: '0 1 auto',
  animationDuration: '1.2s',
  animationTimingFunction: 'ease-out',
  /* Types */
  /* Colors */
},
'cannonConfetti:nth-child(even)': {
  animation: '$confettiRotateL',
},
'@keyframes confettiRotateL': {
  '0%': { transform: 'rotate(0) scaleY(1)'},
  '50%': {transform: 'rotate(2turn) scaleY(1.5)'},
  '100%': {transform: 'rotate(2.05turn) scaleY(1)'},
},
'cannonConfetti:nth-child(odd)': {
  animation: '$confettiRotateR',
},
'@keyframes confettiRotateR': {
  '0%': {transform: 'rotate(0) scaleY(1)'},
  '50%': {transform: 'rotate(-2turn) scaleY(1.5)'},
  '100%': {transform: 'rotate(-2.05turn) scaleY(1)'},
},
cannonConfettiRibbon: {
  height: '1em',
  width: '0.5em',
  borderRadius: '0.1em',
},
cannonConfettiFlake: {
  height: '0.5em',
  width: '0.5em',
  borderRadius: '50%',
},
ConfettiColor1: {
  backgroundColor: '#feb535',
},
ConfettiColor2: {
  backgroundColor: '#bea4ff',
},
ConfettiColor3: {
  backgroundColor: '#ff6e83',
},
ConfettiColor4: {
  backgroundColor: '#58cafe',
},


}));

const Step0Intro = (props: {
  setActiveStep: (num: number) => void;
  group: Group;
}) => {

  const button = document.querySelector('.book-now')
  const [animate, setAnimate] = useState(false);
  const classes = useStyles();
  const { group } = props;
  const imageBanner = group!.tour!.image_banner_url;


  return (
    <React.Fragment>
      <Grid
        className={classes.root}
        container
        spacing={3}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item sm={8}>
          <Typography variant="h1" className={classes.heading}>
            {group!.name} <br/>is invited to <br/> {group!.tour!.display_name}
          </Typography>
        </Grid>

        {imageBanner && (
          <Grid item xs={12}>
            <img src={getHost() + imageBanner} className={classes.image} />
          </Grid>
        )}

        <Grid item xs={12}>
            <div className={classes.bookNowContainer}>
                <Button
                onClick={() => {
                  //
                  setAnimate(true);
                  setTimeout(() => {props.setActiveStep(1); setAnimate(false);}, 1000);
                }}
                color="primary"
                variant="outlined"
                size="medium"
                className={clsx({
                  [classes.button] : true,
                  [classes.bookNow] : true,
                  [classes.cannonExplosion] : animate
                })}
                >
                Book Now  <div className={clsx(classes.partyPopper)}>🎉</div><div className={clsx(classes.cannon)}>
  <div className={clsx([classes.cannonPath, classes.cannonPathSm, classes.cannonPathAngle22])}>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor3])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor1])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor2])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor1])}></div>
  </div>
  <div className={clsx([classes.cannonPath, classes.cannonPathMd, classes.cannonPathAngle11])}>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor2])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor2])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor3])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor1])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor4])}></div>
  </div>
  <div className={clsx([classes.cannonPath, classes.cannonPathLg, classes.cannonPathAngle0])}>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor1])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor4])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor2])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor3])}></div>
  </div>
  <div className={clsx([classes.cannonPath, classes.cannonPathMd, classes.cannonPathAngle1])}>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor3])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor1])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor4])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor3])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor2])}></div>
  </div>
  <div className={clsx([classes.cannonPath, classes.cannonPathSm, classes.cannonPathAngle2])}>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor2])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor3])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiFlake , classes.ConfettiColor4])}></div>
    <div className={clsx([classes.cannonConfetti , classes.cannonConfettiRibbon , classes.ConfettiColor1])}></div>
  </div>
</div>
                </Button>
            </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Step0Intro;
